import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Bell, Loader2 } from "lucide-react";
import { Reveal, SectionHeading } from "./Atoms";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const UpdatesForm = () => {
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    city_state: "",
    connection: "",
    consent: true,
  });
  const [loading, setLoading] = useState(false);
  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.first_name.trim() || !form.last_name.trim() || !form.email.trim()) {
      toast.error("Please fill in your name and email.");
      return;
    }
    if (!form.consent) {
      toast.error("Please consent to receive ministry updates.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/updates-signups`, form);
      toast.success("You're connected to RFMG Updates. Welcome to the movement.");
      setForm({ first_name: "", last_name: "", email: "", phone: "", city_state: "", connection: "", consent: true });
    } catch (err) {
      toast.error("We couldn't submit right now. Please try again shortly.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="updates" className="relative py-28 px-6 section-ember">
      <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <Reveal>
            <SectionHeading
              overline="Stay Connected"
              title={<>Join <span className="italic gold-text">RFMG</span> Updates</>}
              subtitle="Receive ministry announcements, prayer gatherings, revival service information, fasting calls, teachings, service recordings, fundraisers, Fire Hub updates, tent revival announcements, crusade updates, and ministry events."
            />
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <form
              onSubmit={submit}
              className="bento-card !p-7 sm:!p-10 space-y-6"
              data-testid="updates-form"
            >
              <span className="glow-blob" />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="field-label">First Name</label>
                  <input
                    data-testid="updates-first-name"
                    className="input-fire"
                    value={form.first_name}
                    onChange={(e) => update("first_name", e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label className="field-label">Last Name</label>
                  <input
                    data-testid="updates-last-name"
                    className="input-fire"
                    value={form.last_name}
                    onChange={(e) => update("last_name", e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="field-label">Email</label>
                  <input
                    data-testid="updates-email"
                    type="email"
                    className="input-fire"
                    value={form.email}
                    onChange={(e) => update("email", e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label className="field-label">Phone <span className="opacity-60 normal-case tracking-normal">(optional)</span></label>
                  <input
                    data-testid="updates-phone"
                    className="input-fire"
                    value={form.phone}
                    onChange={(e) => update("phone", e.target.value)}
                  />
                </div>
              </div>
              <div>
                <label className="field-label">City / State</label>
                <input
                  data-testid="updates-city"
                  className="input-fire"
                  placeholder="e.g. Atlanta, GA"
                  value={form.city_state}
                  onChange={(e) => update("city_state", e.target.value)}
                />
              </div>
              <div>
                <label className="field-label">How are you connected to the ministry?</label>
                <textarea
                  data-testid="updates-connection"
                  className="input-fire"
                  rows={3}
                  placeholder="Share briefly…"
                  value={form.connection}
                  onChange={(e) => update("connection", e.target.value)}
                />
              </div>
              <label className="check-wrap">
                <input
                  type="checkbox"
                  data-testid="updates-consent"
                  checked={form.consent}
                  onChange={(e) => update("consent", e.target.checked)}
                />
                I consent to receive ministry announcements, prayer calls, and event invitations from Revival Fire Ministries Global.
              </label>

              <button
                type="submit"
                className="btn-fire w-full sm:w-auto"
                disabled={loading}
                data-testid="updates-submit"
              >
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Bell className="h-4 w-4" strokeWidth={1.7} />}
                {loading ? "Joining…" : "Join RFMG Updates"}
              </button>
            </form>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default UpdatesForm;
